<template>
  <b-overlay 
    :show="busy" 
    variant="dark"
  >
    <b-container class="animated fadeIn">
      <b-dropdown 
        right 
        class="float-right" 
        @click="() => {}"
      >
        <template #button-content>
          <i class="fa fa-cog" /> Instellingen
        </template>
         
              
        <b-dropdown-group header="Filters">
          <b-dropdown-form style="width: 350px;">
            <b-dropdown-item @click="includeArchief = !includeArchief">
              <b-form-checkbox v-model="includeArchief">
                Show gefactureerd
              </b-form-checkbox>
            </b-dropdown-item>
            <b-dropdown-item @click="includeOverig = !includeOverig">
              <b-form-checkbox v-model="includeOverig">
                Zoek inclusief overig
              </b-form-checkbox>
            </b-dropdown-item>
        
          
            <inspecteur-select
              :value="selectedAuditor"
              :allow-beheerders="true"
              :eigen-groep-alleen="true"
              @input="selectedAuditor = $event ? { Id: $event.id, Naam: $event.naam } : null"
            />
          </b-dropdown-form>
        </b-dropdown-group>
        <b-dropdown-group header="Downloads">
          <b-dropdown-item-button @click="downloadExcel">
            Download excel <font-awesome-icon icon="file-excel" />
          </b-dropdown-item-button>
        </b-dropdown-group>
      </b-dropdown>
      
      <b-button-toolbar class="mb-3">
        <b-button
          :to="{name: 'NieuweOfferte'}"
          icon="fa fa-save"
          variant="success"
          class="mr-2"
        >
          <i class="fa fa-plus" /> Offerte
        </b-button>
        <b-nav tabs>
          <b-nav-item 
            v-for="(fase) in fasen" 
            :key="fase"
            :to="{name: 'Verkoop',params: { status: fase.toLowerCase()}}"
          >
            {{ fase }}
          </b-nav-item>
        </b-nav>
        <b-input-group class="ml-3">
          <b-input 
            v-model="filter" 
            debounce="500"
            type="search" 
            placeholder="Zoeken..." 
          />
        </b-input-group>
      </b-button-toolbar>
    
      <b-table 
        ref="table"
        :fields="['datum','nummer','relatie','account','naam','bedrag','activiteiten']"
        :items="filteredOffertes"
        :filter="filter"
        :tbody-tr-class="rowClass"
        striped
        bordered 
        selectable
        hover
        select-mode="single"
        @row-details-clicked="clickOfferte"
        @row-clicked="clickOfferte"
      >
        <template #cell(relatie)="row">
          {{ row.item.relatie ? row.item.relatie.naam : '-geen relatie geselecteerd-' }}
        </template>

        <template #cell(datum)="row">
          {{ moment(row.item.datum).format('DD-MM-YY') }}
        </template>

        <template #cell(account)="row">
          {{ row.item.toegewezen_aan ? row.item.toegewezen_aan.Naam.split(' ')[0] : '-' }}
        </template>

        <template #cell(activiteiten)="row">
          {{ row.item.activiteiten.join(', ') }}
        </template>

        <template 
          #cell(bedrag)="row" 
        >
          <div style="text-align:right;">
            {{ row.item.bedrag | formatNumber() }}
          </div>
        </template>
        <template 
          #row-details="row" 
          class="m-0 p-0"
        >
          <b-card @click="() => clickOfferte(row.item)">
            {{ row.item.omschrijving }}
          </b-card>
        </template>
      </b-table>
    
      <b-button 
        variant="primary" 
        @click="downloadExcel"
      >
        <font-awesome-icon icon="download" /> Download excel
      </b-button>

      <b-modal 
        v-if="offerte"
        v-model="showMenu"
        :title="`Offerte ${offerte.nummer}`" 
        @hide="offerte = null"
      >
        <openstaand 
          :offerte="offerte" 
          @edit="gotoOfferte"
          @delete="onDeleteOfferte"
          @opdracht="onMakeOpdracht"
          @afgewezen="onGeenOpdracht"
        />
      </b-modal>
      <router-view 
        @update="onUpdateOfferte" 
        @delete="onDeleteOfferte"
      />
    </b-container>
  </b-overlay>
</template>

<script>
import { serviceMixin } from "@/mixins/serviceMixin";
import { verkoopMixin } from "@/mixins/verkoopMixin";
import Openstaand from './Openstaand.vue';
import InspecteurSelect from '@/components/InspecteurSelect.vue';
import { saveAs } from "file-saver";

export default {
  name: "Offertes",
  components: {
    Openstaand,
    InspecteurSelect
  },
  mixins: [serviceMixin, verkoopMixin],
  props: {
    status: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      busy: false,
      offertes: [],
      offerte: null,
      filter: null,
      showMenu: false,
      selectedAuditor: null,
      includeOverig: true,
      includeArchief: false
    };
  },
  computed: {
    fasen: function() {
      return this.includeArchief ?  [ 'Openstaand', 'Opdracht', 'Gereed', 'Gefactureerd', 'Geen opdracht' ] :
        [ 'Openstaand', 'Opdracht', 'Gereed', 'Geen opdracht' ]
    },
    tabRoute: function () {
      return this.$route.matched[1].name
    },
    filteredOffertes: function () {
      var o = this.offertes
      if (this.includeOverig == false) o = o.filter(i => (i.activiteiten.includes('Overige') == false || i.activiteiten.length > 1));
      if (this.selectedAuditor !== null) o = o.filter(i => (i.toegewezen_aan ? i.toegewezen_aan.Id : 0) == this.selectedAuditor.Id)
      return o.map(row => { return  {...row, _showDetails : ((row.omschrijving || "").length)}})
    }
  },
  watch: {
    offerte: {
      handler(offerte) {
        this.showMenu = (offerte != null)
      }
    },
    status: {
      immediate: true,
      handler: function(newval) {
        console.log('trigger status', newval);
        if (newval !== null) this.getOffertes();
      }
    }
  },
  mounted() {
    this.getOffertes();
  },
  methods: {
    downloadExcel() {
      // var vm = this;
      var endpoint = `/offertes/${this.status}/excel`;
      this.getBlob(endpoint).then(function(resp) {
        console.log(resp);
        var blob = new Blob([resp.data], {
            type:
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
          });
          saveAs(blob, "verkoop-download.xlsx");
      })
      .catch(function(error) {
        console.log(error)
      })
    },
    rowClass(item, type) {
        if (!item || type === 'row-details') return 'dark';
    },
    onMakeOpdracht: function(o) {
      var vm = this;
      this.offerte = null;
      o.status = "OPDRACHT";
      this.updateTraject(`/offertes/offerte/${o.id}`, { offerte: o })
        .then(() => vm.$router.push({
          name: 'Opdracht', 
          params: {
            id: o.id,
            status: o.status.toLowerCase()
          }
        }));
    },
    onGeenOpdracht: function(o) {
      var vm = this;
      this.offerte = null;
      o.status = "GEEN OPDRACHT";
      this.updateTraject(`/offertes/offerte/${o.id}`, { offerte: o })
        .then(() => vm.getOffertes());
    },
    clickOfferte: function(row) {
      console.log(row);
      (row.status.toLowerCase() == 'openstaand') ? this.offerte = row : this.gotoOpdracht(row);
    },
    gotoOfferte: function(row) {
      this.offerte = null;
      this.$router.push({name: 'BewerkOfferte',params: {id: row.id}})
    },
    gotoOpdracht: function(opdracht) {
      this.$router.push({name: 'Opdracht', params:{id:opdracht.id}});
    },
    getOffertes: function () {
      var vm = this;
      this.busy=true;
      vm.offertes= [];
      //this.get(`/offertes/${this.status}`)
      this.get(`/offertes/${this.status}/zoeken`)
        .then(function (response) {
          console.log(response.data);
          vm.offertes = response.data.offertes;
        })
        .catch(function (error) {
          console.log(error);
        }).finally(()=> vm.busy = false);
    },
    onUpdateOfferte(offerte) {
      console.log('onUpdateOfferte',offerte)
      this.getOffertes();
    },
    onDeleteOfferte(offerte) {
      console.log('onDeleteOfferte')
      var indx = this.offertes.map(o => o.id).indexOf(offerte.id)
      console.log(indx)
      this.offertes.splice(indx,1)
      this.$refs.table.refresh();
    }
  },
};
</script>
